import React, { useEffect, useMemo, useState } from "react"
import { get, isEmpty, find, findKey, isNil } from "lodash"

import APIs from "redux/apis"
import { IndustryRatioTemplate } from "components/templates/domestic/indexes"
import { withRouter, WithRouterProps } from "react-router"
import { APIResponse } from "redux/apis/types"
import { getRequestName } from "config/apiConst"
import { parseQueryString, checkIsSp } from "utils/util"
import { ParsedQs } from "qs"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { changeSymbol } from "redux/ducks/Chart"
import { useDispatch } from "react-redux"
import { useLodingTrigger, LoadingTriger } from "components/actions/loading"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

const TPSectorsList = [
  {
    id: 0,
    symbol: "321",
    name: "水産・農林業",
    num: "100000000000000000000000000000000",
    JSecCode: "0050",
  },
  {
    id: 1,
    symbol: "324",
    name: "食料品",
    num: "010000000000000000000000000000000",
    JSecCode: "3050",
  },
  {
    id: 2,
    symbol: "322",
    name: "鉱業",
    num: "001000000000000000000000000000000",
    JSecCode: "1050",
  },
  {
    id: 3,
    symbol: "329",
    name: "石油・石炭製品",
    num: "000100000000000000000000000000000",
    JSecCode: "3300",
  },
  {
    id: 4,
    symbol: "323",
    name: "建設業",
    num: "000010000000000000000000000000000",
    JSecCode: "2050",
  },
  {
    id: 5,
    symbol: "334",
    name: "金属製品",
    num: "000001000000000000000000000000000",
    JSecCode: "3550",
  },
  {
    id: 6,
    symbol: "331",
    name: "ガラス・土石製品",
    num: "000000100000000000000000000000000",
    JSecCode: "3400",
  },
  {
    id: 7,
    symbol: "325",
    name: "繊維製品",
    num: "000000010000000000000000000000000",
    JSecCode: "3100",
  },
  {
    id: 8,
    symbol: "326",
    name: "パルプ・紙",
    num: "000000001000000000000000000000000",
    JSecCode: "3150",
  },
  {
    id: 9,
    symbol: "327",
    name: "化学",
    num: "000000000100000000000000000000000",
    JSecCode: "3200",
  },
  {
    id: 10,
    symbol: "328",
    name: "医薬品",
    num: "000000000010000000000000000000000",
    JSecCode: "3250",
  },
  {
    id: 11,
    symbol: "330",
    name: "ゴム製品",
    num: "000000000001000000000000000000000",
    JSecCode: "3350",
  },
  {
    id: 12,
    symbol: "337",
    name: "輸送用機器",
    num: "000000000000100000000000000000000",
    JSecCode: "3700",
  },
  {
    id: 13,
    symbol: "332",
    name: "鉄鋼",
    num: "000000000000010000000000000000000",
    JSecCode: "3450",
  },
  {
    id: 14,
    symbol: "333",
    name: "非鉄金属",
    num: "000000000000001000000000000000000",
    JSecCode: "3500",
  },
  {
    id: 15,
    symbol: "335",
    name: "機械",
    num: "000000000000000100000000000000000",
    JSecCode: "3600",
  },
  {
    id: 16,
    symbol: "336",
    name: "電気機器",
    num: "000000000000000010000000000000000",
    JSecCode: "3650",
  },
  {
    id: 17,
    symbol: "338",
    name: "精密機器",
    num: "000000000000000001000000000000000",
    JSecCode: "3750",
  },
  {
    id: 18,
    symbol: "339",
    name: "その他製品",
    num: "000000000000000000100000000000000",
    JSecCode: "3800",
  },
  {
    id: 19,
    symbol: "345",
    name: "情報・通信業",
    num: "000000000000000000010000000000000",
    JSecCode: "5250",
  },
  {
    id: 20,
    symbol: "353",
    name: "サービス業",
    num: "000000000000000000001000000000000",
    JSecCode: "9050",
  },
  {
    id: 21,
    symbol: "340",
    name: "電気・ガス業",
    num: "000000000000000000000100000000000",
    JSecCode: "4050",
  },
  {
    id: 22,
    symbol: "341",
    name: "陸運業",
    num: "000000000000000000000010000000000",
    JSecCode: "5050",
  },
  {
    id: 23,
    symbol: "342",
    name: "海運業",
    num: "000000000000000000000001000000000",
    JSecCode: "5100",
  },
  {
    id: 24,
    symbol: "343",
    name: "空運業",
    num: "000000000000000000000000100000000",
    JSecCode: "5150",
  },
  {
    id: 25,
    symbol: "344",
    name: "倉庫・輸送関連業",
    num: "000000000000000000000000010000000",
    JSecCode: "5200",
  },
  {
    id: 26,
    symbol: "346",
    name: "卸売業",
    num: "000000000000000000000000001000000",
    JSecCode: "6050",
  },
  {
    id: 27,
    symbol: "347",
    name: "小売業",
    num: "000000000000000000000000000100000",
    JSecCode: "6100",
  },
  {
    id: 28,
    symbol: "348",
    name: "銀行業",
    num: "000000000000000000000000000010000",
    JSecCode: "7050",
  },
  {
    id: 29,
    symbol: "349",
    name: "証券、商品先物取引業",
    num: "000000000000000000000000000001000",
    JSecCode: "7100",
  },
  {
    id: 30,
    symbol: "350",
    name: "保険業",
    num: "000000000000000000000000000000100",
    JSecCode: "7150",
  },
  {
    id: 31,
    symbol: "351",
    name: "その他金融業",
    num: "000000000000000000000000000000010",
    JSecCode: "7200",
  },
  {
    id: 32,
    symbol: "352",
    name: "不動産業",
    num: "000000000000000000000000000000001",
    JSecCode: "8050",
  },
]

export const IndustryRatio: WithRouterProps<React.FC> = withRouter(
  ({ location }) => {
    const [industryData, setIndustryData] = useState({})
    const [constituentsData, setConstituentsData] = useState({})
    const [industryNum, changeIndustryNum] = useState<number>()
    const [constituentsNum, changeConstituentsNum] = useState<number>(0)
    const [queryIndustryCode, setQueryIndustryCode] = useState(null)
    const [detailData, setDetailData] = useState<APIResponse.Res | []>([])
    const [industryListNum, changeIndustryListNum] = useState<number>(0)
    const [constituentsDataSp, setConstituentsDataSp] = useState({})
    const { loading, setLoading } = useLodingTrigger()
    const isPageLoading = useSelector(
      (state: { PageLoad: LoadStateType }) => state.PageLoad.load
    )

    const industryChartId = useMemo(() => {
      return uuid()
    }, [])

    const constituentsChartId = useMemo(() => {
      return uuid()
    }, [])
    const loadResistId = useMemo(() => uuid(), [])
    const dispatch = useDispatch()
    const isSp = checkIsSp()

    const industryItem = {
      data: industryData,
      setData: setIndustryData,
      num: industryNum,
      changeNum: changeIndustryNum,
      listNum: industryListNum,
      changeListNum: changeIndustryListNum,
    }
    const constituentsItem = {
      data: constituentsData,
      setData: setConstituentsData,
      num: constituentsNum,
      changeNum: changeConstituentsNum,
      dataSp: constituentsDataSp,
    }
    const detailItem = {
      data: detailData,
      setData: setDetailData,
    }
    const chartID = {
      industry: industryChartId,
      constituents: constituentsChartId,
    }

    const loadIndustryData = async () => {
      store.dispatch(pageLoadRegist(loadResistId, true))
      const industry: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList({
        Name: getRequestName(location.pathname),
      })
      setIndustryData(industry)
      const code: ParsedQs | null = !!location.search
        ? parseQueryString(location.search)
        : null
      if (!!code) {
        const industry = find(TPSectorsList, {
          JSecCode: get(code, "code", null),
        })
        setQueryIndustryCode(get(industry, "symbol"))
      } else {
        !isSp ? changeIndustryNum(0) : changeIndustryListNum(0)
      }
      store.dispatch(pageLoadRegist(loadResistId, false))
    }

    const loadConstituentsData = async (
      selectNum: number,
      setData: Function
    ) => {
      const industryResult = get(industryData, "ResultList")
      const transitionData = find(TPSectorsList, {
        JSecCode: get(parseQueryString(location.search), "code", null),
      })
      let currentNum = selectNum

      if (transitionData) {
        const activePosition = findKey(industryResult, (row: object) => {
          const symbol = get(transitionData, "symbol")
          return get(row, "Symbol") === symbol
        })
        currentNum = Number(activePosition)
      }
      const currentSymbol = get(industryResult[currentNum], "Symbol")
      const TPSectors = get(
        find(TPSectorsList, (list: object) => {
          return get(list, "symbol") === currentSymbol
        }),
        "num"
      )
      const _loadConstituentsData = async () => {
        store.dispatch(pageLoadRegist(loadResistId, true))
        const constituents:
          | APIResponse.Res
          | {} = await APIs.SymbolDetail.EquitySymbolList({
          TPSectors: TPSectors,
          _where: "Exchange=MainExchange",
        })
        setData(constituents)
        store.dispatch(pageLoadRegist(loadResistId, false))
      }
      _loadConstituentsData()
    }

    //初回（業種データ取得とSymbolDetailから遷移してきたか確認）
    useEffect(() => {
      loadIndustryData()
    }, [])

    //ページ更新
    useEffect(() => {
      if (isPageLoading) loadIndustryData()
    }, [isPageLoading])

    useEffect(() => {
      if (!loading) return
      setLoading(false)
      loadIndustryData()
    }, [loading])

    //個別銘柄詳細から遷移してきた場合に対象の業種に合わせる
    useEffect(() => {
      if (isEmpty(industryData)) return
      if (isEmpty(location.search)) {
        !isSp ? changeIndustryNum(0) : changeIndustryListNum(0)
      } else {
        const resultList = get(industryData, "ResultList")
        !isSp
          ? changeIndustryNum(
              Number(findKey(resultList, { Symbol: queryIndustryCode }))
            )
          : changeIndustryListNum(
              Number(findKey(resultList, { Symbol: queryIndustryCode }))
            )
      }
    }, [queryIndustryCode])

    //構成銘柄データ取得:PC
    useEffect(() => {
      if (isEmpty(industryData) || isNil(industryNum) || isSp) return
      loadConstituentsData(industryNum, setConstituentsData)
    }, [industryData, industryNum])

    //構成銘柄データ取得:SP
    useEffect(() => {
      if (isEmpty(industryData) || isNil(industryListNum) || !isSp) return
      loadConstituentsData(industryListNum, setConstituentsDataSp)
    }, [industryData, industryListNum])

    //個別銘柄詳細から遷移してきた場合に対象の構成銘柄に合わせる
    useEffect(() => {
      if (isEmpty(constituentsData) || isEmpty(location.search) || isSp) return
      const resultList = get(constituentsData, "ResultList")
      const transitionData = parseQueryString(location.search)
      const currentNum = Number(
        findKey(resultList, {
          Symbol: get(transitionData, "symbol"),
        })
      )
      if (currentNum) {
        changeConstituentsNum(currentNum)
        store.dispatch(pageLoadRegist(loadResistId, true))
        dispatch(changeSymbol(constituentsChartId, resultList[currentNum]))
        const callDetail = async () => {
          const SecurityType = get(resultList[currentNum], "SecurityType")
          const Exchange = get(resultList[currentNum], "Exchange")
          const Symbol = get(resultList[currentNum], "Symbol")
          const res = await APIs.SymbolDetail.SymbolDetail({
            SecurityType: SecurityType,
            Exchange: Exchange,
            Symbol: Symbol || "",
          })
          if (get(res, "Result") === 0) {
            setDetailData(get(res, "Symbol"))
          }
          location.search = ""
          store.dispatch(pageLoadRegist(loadResistId, false))
        }
        callDetail()
      }
    }, [constituentsData])

    return (
      <LoadingTriger.Provider value={{ loading, setLoading }}>
        <IndustryRatioTemplate
          industryItem={industryItem}
          constituentsItem={constituentsItem}
          detailItem={detailItem}
          location={location}
          chartID={chartID}
        />
      </LoadingTriger.Provider>
    )
  }
)
